import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CollectionCard from "@/components/molecules/create-collection/collection-card";
import { useOwner } from "@/context/OwnerContext";
import LoadMoreButton from "@/components/atomics/load-more-button";
import { useWallet } from "@/context/WalletContext";
import CollapsibleGroup from "@/components/atomics/collapsible-group";
import { OwnerCollectionData } from "@/types/collection";
import { ownerdata } from "@/data/owner-data";
import { backend } from "@/services/backend";
interface OwnerCollectionProps {
  collectionData: OwnerCollectionData[];
}

const limit_count = 4;

export default function OwnerCollection({
  collectionData,
}: OwnerCollectionProps) {
  const navigate = useNavigate();
  const [displayCount, setDisplayCount] = useState(4);
  const [isLoading, setIsLoading] = useState(false);
  const [showOwnerView, setShowOwnerView] = useState(false);
  const { isEditView, isOwnerView, fireTrigger } = useOwner();
  const { walletAddress } = useWallet();
  const { address } = useParams();
  const [displayCollectionData, setDisplayCollectionData] =
    useState<OwnerCollectionData[]>(collectionData);

  useEffect(() => {
    setDisplayCount(Math.min(limit_count, collectionData.length));
    setDisplayCollectionData(collectionData);
  }, [collectionData]);

  useEffect(() => {
    if (walletAddress) {
      if (walletAddress === address) {
        setShowOwnerView(true);
      } else {
        setShowOwnerView(false);
      }
    }
  }, [walletAddress, address]);

  const handleLoadMore = () => {
    setIsLoading(true);
    setTimeout(() => {
      if (displayCount >= collectionData.length) {
        setDisplayCount(limit_count);
      } else {
        setDisplayCount(prev => prev + limit_count);
      }
      setIsLoading(false);
    }, 300);
  };

  const handleHide = (collection: string, isHidden: boolean) => {
    if (!walletAddress) return;
    backend
      .hideCollectionByOwner({
        address: walletAddress,
        collection,
        hide: !isHidden,
      })
      .then(res => {
        console.log("Response:", res);
        setDisplayCollectionData(state =>
          state.map(item => {
            if (item.address === collection) {
              return { ...item, is_hidden_by_owner: !item.is_hidden_by_owner };
            }
            return item;
          })
        );
        // res.success && fireTrigger();
      })
      .catch(console.error);
  };

  return (
    <CollapsibleGroup
      isEditView={isEditView}
      withEdit={true}
      editTitle={
        isOwnerView && showOwnerView ? "MY COLLECTION" : "WALLET COLLECT."
      }
      viewTitle={
        isOwnerView && showOwnerView ? "MY COLLECTION" : "WALLET COLLECT."
      }
      className={`${
        collectionData.length > 0
          ? "pointer-events-auto"
          : "pointer-events-none"
      }`}
      extendedViewClassName={`w-full px-[30px] py-[15px] text-[30px] ${
        collectionData.length > 0
          ? "bg-white text-black"
          : "bg-black text-white"
      }`}
      collapsedViewClassName="w-full px-[30px] py-[15px] text-[30px] bg-black text-white"
    >
      <div
        className={`w-full bg-white px-[30px] ${
          collectionData.length > 0 ? "pt-[20px] pb-[20px]" : ""
        }`}
      >
        <div className="grid grid-cols-2 gap-[10px] transition-all duration-500 ease-in-out">
          {displayCollectionData?.slice(0, displayCount).map((item, index) => (
            <CollectionCard
              key={index}
              className={`w-full flex-shrink-0 transition-all duration-300 ease-in-out hover:cursor-pointer ${
                isLoading ? "animate-pulse opacity-60" : "opacity-100"
              }`}
              onClick={
                !isEditView
                  ? () => navigate(`/collection/${item.address}`)
                  : () => handleHide(item.address, !!item.is_hidden_by_owner)
              }
              data_url={item.data_url}
              value={item.price / 1000000000}
              totalMintCount={item.mint_limit}
              currentMintedCount={item.next_item_index}
              isEditView={isEditView}
              is_hidden={item.is_hidden_by_owner}
              is_owner_edit={isEditView}
            />
          ))}
        </div>
        {collectionData.length > limit_count && (
          <LoadMoreButton
            isLoading={isLoading}
            hasMore={displayCount < collectionData.length}
            onLoadMore={handleLoadMore}
          />
        )}
      </div>
    </CollapsibleGroup>
  );
}
